<div [ngStyle]="{ 'display' : this.calculationsService.procedureAnalysisResultActive? 'block' : 'none'}" [ngClass]="tabsService.minimizeScreenMode ? 'bottom-menu minimized' : ''">
  <div class="loading" [ngClass]="loading ? 'active' : ''">
    <div></div>
  </div>

  <form autocomplete="off"  id="ngForm" name="ngForm" #ngForm="ngForm" [ngClass]="[this.calculationsService.procedureAnalysisResultActive ? 'active procedureAnalysis' : 'procedureAnalysis',  tabsService.fullScreenMode ? 'fullscreen' : '']" data-tab="1" id="coordindatePointsForm">
    <div class="fields__block small" *ngIf="calculationsService.displayCalculation.displayLeftColumnInfomation">
      <div *ngIf="calculationsService.displayCalculation.displayLegend" class="fields__block__section">
        <div class="title">
          <h4 style="margin: 0; width: 100%;">{{calculationsService.displayCalculation.legendTitle}}</h4>
        </div>
        <div *ngIf="calculationsService.procedureCalculationType == 1" class="legend">
          <label>
            <span style="background-color: #75736b"></span>
            No coverage
          </label>
          <label>
            <span style="background-color: #f66f68"></span>
            No Redundancy
          </label>
          <label>
            <span style="background-color: #f5f46d"></span>
            Limited Redundancy
          </label>
          <label>
            <span style="background-color: #75f46b"> </span>
            Full Redundancy
          </label>
          <label>
            <span style="background-color: #7978eb"> </span>
            High Redundancy
          </label>
        </div>
        <div *ngIf="calculationsService.procedureCalculationType == 0" class="legend">
          <label>
            <span style="background-color: #75736b"></span>
            0 - 30
          </label>
          <label>
            <span style="background-color: #ffc8c8"></span>30 - 40
          </label>
          <label>
            <span style="background-color: #ff8282"></span>40 - 50
          </label>
          <label>
            <span style="background-color: #f5f46d"> </span>50 - 60
          </label>
          <label>
            <span style="background-color: #7978eb"> </span>60 - 70
          </label>
          <label>
            <span style="background-color: #d967da"> </span>70 - 80
          </label>
          <label>
            <span style="background-color: #50ff50"> </span>80 - 90
          </label>
        </div>
        <div *ngIf="calculationsService.procedureCalculationType == 2 && calculationsService.procedureChartType == 'bar'" class="legend">
          <label>
            <span style="background-color: #00ff00"></span>0 - 0.2
          </label>
          <label>
            <span style="background-color: #50ff50"></span>0.2 - 0.4
          </label>
          <label>
            <span style="background-color: #82ff82"></span>0.4 - 0.6
          </label>
          <label>
            <span style="background-color: #c8ffc8"> </span>0.6 - 0.866
          </label>
          <label>
            <span style="background-color: #ffc8c8"> </span>0.866 - 1
          </label>
          <label>
            <span style="background-color: #ff8282"> </span>1 - 2
          </label>
          <label>
            <span style="background-color: #ff5050"> </span>2 - 3
          </label>
          <label>
            <span style="background-color: #ff0000"> </span>> 3
          </label>
          <label>
            <span style="background-color: #75736b"> </span>VOID
          </label>
        </div>
        <div *ngIf="calculationsService.procedureCalculationType == 2 && calculationsService.procedureChartType == 'plot'" class="legend-line">
          <label>
            <span style="background-color: #00ff00"></span> Coverage
          </label>
          <label>
            <span style="background-color: #75736b"></span>No Coverage
          </label>
        </div>
      </div>
      <div class="fields__block__section" *ngIf="calculationsService.displayCalculation.displayContinuity">
        <div class="title">
          <h4 style="width: 100%">Continuity Information</h4>
        </div>
        <div>
          <label>Average Continuity: </label>
          <label> {{ calculationsService.procedureSegmentContinuity.averageContinuity }}</label>
        </div>
        <div>
          <label>Minimum Continuity: </label>
          <label> {{ calculationsService.procedureSegmentContinuity.minimumContinuity }}</label>
        </div>
        <div class="table-fields">
          <div style="margin-right:0; width: 100%; overflow-y: auto;">
            <table>
              <thead>
                <tr>
                  <th scope="col">Segment</th>
                  <th scope="col">Continuity</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let segment of calculationsService.procedureSegmentContinuity.continuity | keyvalue">
                  <td>{{segment.key}}</td>
                  <td>{{segment.value}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="fields__block large">
        <div class="fields__block__section">
            <div class="title">
              <h4 style="width: 100%">{{ calculationsService.displayCalculation.title }}</h4>
            </div>
            <div>
              <canvas id="chart1" width="1320" height="250" backgroundColor="white"></canvas>
            </div>
            <button type="button" id="copyToClipboard" (click)="getCanvasUrl('chart1')" class="btn" [disabled]="loading">Copy to Clipboard</button>
            <div>
              <canvas *ngIf="calculationsService.displayCalculation.displayWorstInertialChart" id="chartWorstNSEIntertial" width="1320" height="250" backgroundColor="white"></canvas>
            </div>
            <button type="button" *ngIf="calculationsService.displayCalculation.displayWorstInertialChart" id="copyToClipboardWorstInertial" (click)="getCanvasUrl('chartWorstNSEIntertial')" class="btn" [disabled]="loading">Copy to Clipboard</button>
            <div >
              <canvas *ngIf="calculationsService.displayCalculation.displaySecondChart" id="chart2" width="1320" height="250"></canvas>
            </div>
            <button type="button" *ngIf="calculationsService.displayCalculation.displaySecondChart" id="copyToClipboard2" (click)="getCanvasUrl('chart2')" class="btn" [disabled]="loading">Copy to Clipboard</button>
            <div>
              <canvas *ngIf="calculationsService.displayCalculation.displayCenterInertialChart" id="chartCenterNSEIntertial" width="1320" height="250" backgroundColor="white"></canvas>
            </div>
            <button type="button" *ngIf="calculationsService.displayCalculation.displayCenterInertialChart" id="copyToClipboardCenterInertial" (click)="getCanvasUrl('chartCenterNSEIntertial')" class="btn" [disabled]="loading">Copy to Clipboard</button>
        </div>
        <div *ngIf="calculationsService.displayCalculation.displayTable" class="fields__block__section" style="margin-top: 18px;">
          <div class="table-fields">
            <div>
              <table>
                <thead>
                  <tr>
                    <th scope="col">Type</th>
                    <th scope="col">Center Value</th>
                    <th scope="col">Full Width</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let redundancy of calculationsService.redundancyPercentage">
                    <td>{{redundancy.type}}</td>
                    <td>{{redundancy.values[0]}}%</td>
                    <td>{{redundancy.values[1]}}%</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              <table>
                <thead>
                  <tr>
                    <th scope="col">Type</th>
                    <th scope="col">Worst Value</th>
                    <th scope="col">Worst Value + Receiver Delay</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let redundancy of calculationsService.redundancyPercentageTable2">
                    <td>{{redundancy.type}}</td>
                    <td>{{redundancy.values[0]}}%</td>
                    <td>{{redundancy.values[1]}}%</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <a class="btn" (click)="exportToCsv()" title="" >Export to CSV</a>
        </div>
    </div>
  </form>
</div>
